import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'

export const DeleteDialog = (props) => {
  const { open, setOpen, deleteJobs, deleteUnivPrintJobs, selected } = props
  const { t } = useTranslation()

  const handleCloseAndDelete = async () => {
    setOpen(false)
    const selectedJobs = Object.values(selected) ?? []
    const r2mJobs = selectedJobs.filter((item) => !item?.isUnivPrintJob).map(item => item.id)
    const univPrintJobs = selectedJobs.filter((item) => item?.isUnivPrintJob).map(item => item.id)
    if (univPrintJobs.length > 0) {
      await deleteUnivPrintJobs(univPrintJobs)
    }
    if (r2mJobs.length > 0) {
      await deleteJobs(r2mJobs)
    }
  };

  const handleClose = () => {
    setOpen(false)
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {t("Delete Jobs")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {
              selected.length > 1 ?
              t('Would you like to delete the selected jobs?')
              :
              t('Would you like to delete the selected job?')
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleClose}
            variant='outlined'
          >{t('No')}</Button>
          <Button 
            onClick={handleCloseAndDelete} 
            autoFocus={true}
            variant='contained'
          >{t('Yes')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}